import { Gruser } from '../../types/papi';
import { AppState, PageSlice } from '../../types/store';
import { getCurrentGruserSlice } from './grusers';

export const getPage = (
  state: any,
  gruser: Gruser | undefined
): PageSlice | undefined => getCurrentGruserSlice(state, gruser).page;

export const getPageName = (
  state: AppState,
  gruser: Gruser | undefined
): string | undefined => getPage(state, gruser)?.name;
